import { combineReducers } from 'redux';
import { configureStore } from '@reduxjs/toolkit';
// import storage from "redux-persist/lib/storage"; // Use local storage
import storage from 'redux-persist/lib/storage/session'; // Use session storage
import { persistReducer, persistStore } from "redux-persist";
import auth from './reducers/auth';
import artistDetails from './reducers/artistDetails';
import growthEngine from './reducers/growthEngine';
import amplitudeReducer from './reducers/amplitudeAIReducers';
import transform, { audioEngineerTransform } from '../helper/transform';
// import transform from '../helper/transform';
import { growthEngineTransform, dataAnalysisTransform, backgroundProcessesTransform } from "../helper/transform";
import dataAnalystReducers from './reducers/dataAnalyst';
import audioEngineerReducers from './reducers/audioEngineerReducers';
import billingReducer from './reducers/billing';
import artistManagerReducer from './reducers/artistManagerReducer';
import backgroundProcessesReducer from './reducers/backgroundProcesses';
// Configuration for Redux Persist
// const persistConfig = {
//     key: "growthEngine", // Change to a more general key if you want to persist the entire state
//     storage: storage, // Use local storage
//     whitelist: ["growthEngine"], // Persist only growthEngine
//     transforms: [transform],
// };

const persistConfig = {
    key: "root", 
    storage: storage,
    whitelist: ["auth", "growthEngine", "dataanalyst", "audioEngineer", "backgroundProcesses"],
    transforms: [growthEngineTransform, dataAnalysisTransform, audioEngineerTransform, backgroundProcessesTransform],
};

// Combine reducers
const appReducer = combineReducers({
    auth: auth,
    artistDetails: artistDetails,
    growthEngine:growthEngine,
    amplitudeReducer: amplitudeReducer,
    dataanalyst: dataAnalystReducers,
    billing:billingReducer,
    audioEngineer: audioEngineerReducers,
    artistManager: artistManagerReducer,
    backgroundProcesses: backgroundProcessesReducer,
});

const getAuthUserKey = (details) => {
    if (!details) return null;
    const key =
        details._id ||
        details.id ||
        details.email ||
        details.assignedArtistSongstateId ||
        "";
    return String(key).trim() || null;
};

/**
 * Drop persisted Growth Engine Meta/campaign state on logout and when a
 * different user logs in — prevents prior user's Meta pages/ad accounts
 * from showing on Choose your platform.
 */
const rootReducer = (state, action) => {
    if (action.type === "LOGOUT") {
        return appReducer(
            {
                ...state,
                auth: undefined,
                artistDetails: undefined,
                growthEngine: undefined,
                amplitudeReducer: undefined,
                dataanalyst: undefined,
                billing: undefined,
                audioEngineer: undefined,
                artistManager: undefined,
                backgroundProcesses: undefined,
            },
            action
        );
    }

    if (action.type === "LOGIN" && state) {
        const prevKey = getAuthUserKey(state.auth?.userDetails);
        const nextKey = getAuthUserKey(action.details);
        if (!prevKey || !nextKey || prevKey !== nextKey) {
            return appReducer(
                {
                    ...state,
                    growthEngine: undefined,
                    backgroundProcesses: undefined,
                },
                action
            );
        }
    }

    return appReducer(state, action);
};

// persistReducer(persistConfig, growthEngine)
const persistedReducer = persistReducer(persistConfig, rootReducer);
// Configure the Redux store
const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false, // Required for Redux Persist
        }),
});

// Create the persistor
const persistor = persistStore(store);

// Export store and persistor
export { store, persistor };